exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-box .title-container{margin-bottom:20px}\n", ""]);

